/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

import DoublyLinkedList from './doublylinkedlist';

class Queue<T> {
  data: DoublyLinkedList<T>;

  constructor() {
    this.data = new DoublyLinkedList();
  }

  enqueue(value: T) {
    this.data.unshift(value);
  }

  dequeue(): T {
    return this.data.pop();
  }

  peek(): T | null {
    return this.data.last();
  }

  forEach(cb: (value: T, index: number) => void): void {
    // traverse from tail as new element is added at head.
    this.data.forEachReverse(cb);
  }

  /**
   * Clears the entire queue of messages so they can be garbage collected
   */
  clear(): void {
    this.data.clear();
  }

  get length(): number {
    return this.data.length;
  }
}

export default Queue;
